import React from 'react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="w-full bg-bone px-5 py-20 sm:py-28" data-id="element-15" data-mp="plsje24mow86">
      <div className="mx-auto max-w-6xl" data-id="element-16" data-mp="aua4k7ni97qe">
        <SectionHeading eyebrow="Incluidos hoy gratis" title={<>
              5 Bonos de <span className="text-brand" data-id="element-18" data-mp="1un8809mus47">Ejecución Inmediata</span>
            </>} subtitle="Estos recursos se añaden a tu kit sin costo adicional, diseñados para una inmersión total y un ahorro real de tiempo." data-id="element-17" data-mp="fu6d8k75dnca" />

        <ol className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-19" data-mp="3o3696f3uh0g9">
          {bonuses.map((bonus, index) => <Reveal key={bonus.title} delay={index * 0.04} className="h-full" data-id="element-20" data-mp="3t2sm0nfrgeoj" data-mpi={index}>
              <li className="flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-21" data-mp="1martznsoqa3j">
                <div className="relative border-b-2 border-ink bg-white" data-id="element-22" data-mp="3idmx9swgczdy">
                  <img src={bonus.cover} alt="" loading="lazy" className="mx-auto block h-56 w-full object-cover" data-id="element-23" data-mp="3dfleza6up43j" />
                  <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 font-display text-xs tracking-[0.1em] text-volt" data-id="element-24" data-mp="3n4mwx5wyhvk5">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-25" data-mp="2uibtlnhytgjn">
                  <h3 className="font-display text-xl leading-tight text-ink" data-id="element-26" data-mp="38gikgjohyg9t">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 flex-1 text-base leading-relaxed text-ink/70" data-id="element-27" data-mp="33fujb56k0j1v">
                    {bonus.text}
                  </p>
                  <p className="mt-5 flex flex-wrap items-center gap-2 text-sm font-bold" data-id="element-28" data-mp="ir6ty1nm5maf">
                    <span className="text-ink/40 line-through" data-id="element-29" data-mp="3ciwqenh6xfi3">
                      Valor {bonus.was}
                    </span>
                    <span className="rounded-full bg-volt px-3 py-1 font-display text-xs tracking-[0.1em] text-ink" data-id="element-30" data-mp="3hh8110fb7u1d">
                      Gratis
                    </span>
                  </p>
                </div>
              </li>
            </Reveal>)}

          <Reveal delay={0.24} className="h-full" data-id="element-31" data-mp="2tsf34yf4nc44">
            <li className="flex h-full flex-col items-start justify-center rounded-2xl border-2 border-ink bg-brand p-8 text-white" data-id="element-32" data-mp="2ttq28kxmnvow">
              <p className="font-display text-sm tracking-[0.14em] text-white/80" data-id="element-33" data-mp="2xrntruevetvg">
                Los 5 bonos
              </p>
              <p className="mt-3 font-display text-5xl leading-none" data-id="element-34" data-mp="37kd4uo6ie5q9">
                US$74 incluidos gratis
              </p>
              <p className="mt-4 text-base leading-relaxed text-white/85" data-id="element-35" data-mp="2a3o5d1517fk1">
                Se suman hoy al kit completo, sin cargo adicional.
              </p>
            </li>
          </Reveal>
        </ol>
      </div>
    </section>;
}